<template>
  <div class="csc-details">
    <div v-if="details.IsBlackListed" class="text-very-big text-red">
      <i class="fa fa-fw fa-exclamation-triangle"></i>&nbsp;{{ 'CSCisBlacklisted' | lang}}
    </div>
    <ul v-if="anyproblem" :key="'w' + cidx" class="text-red">
      <li>{{ 'Problems' | lang }}</li>
      <li v-if="details.IsExpired">{{ 'CSCisExpired' | lang}}</li>
      <li v-if="details.IsLocked">{{ 'CSCisLocked' | lang}}</li>
      <li v-if="details.IsInvalid">{{ 'CSCisInvalid' | lang}}</li>
    </ul>
    <ul v-if="anywarning" :key="'w' + cidx" class="orange-red">
      <li>{{ 'Warning' | lang }}</li>
      <li v-if="details.EndPeriodState === 'Expiring'">{{ 'CSCisCloseToExpire' | lang}}</li>
      <li v-if="details.IsSaleUnavailable">{{ 'CSCisSalesUnavailable' | lang}}</li>
      <li v-if="details.IsFull">{{ 'CSCisFull' | lang}}</li>
    </ul>
    <div>
      <div class="form-grid">
        <div>
          <div class="floating-label">
            <input type="text" disabled :value="carddata.MediaSerialNumber + '/' + carddata.MediaUnicity"  />
            <label>{{ 'SerialNumberAndUnicity' | lang }}</label>
          </div>
          <div class="floating-label">
            <input type="text" disabled :value="expirationDate"  />
            <label><i class="fa fa-fw fa-exclamation-triangle" v-if="details.IsExpired"></i>{{ 'ExpirationDate' | lang }}</label>
          </div>
          <!-- <div class="floating-label">
            <input type="text" disabled :value="holderBirthDate"  />
            <label>{{ 'HolderBirthDate' | lang }}</label>
          </div> -->
        </div>
      </div>

      <div v-if="details && details.ContractInfo && details.ContractInfo.length">
        <div v-for="(contract, cidx) in details.ContractInfo" :key="'riquadro-per-stefano' + cidx" class="contract-box">
          <div :key="'t' + cidx" class="jsfixedheader">
            {{contract.TitleProduct}}
            <span v-if="contract.Sold"> (x{{contract.Sold}})</span>
            <span v-if="contract.TitleNetwork"> - {{contract.TitleNetwork}}</span>
          </div>
          <div v-if="contract.SavTemporaryCommercialSuspension" class="text-very-big text-orange">
            <i class="fa fa-fw fa-pause"></i>&nbsp;{{ 'ContractTemporarySuspended' | lang }}
          </div>
          <div v-else-if="contract.SavDefinitiveCommercialSuspension" class="text-very-big text-red">
            <i class="fa fa-fw fa-exclamation-triangle"></i>&nbsp;{{ 'ContractDefinitiveSuspended' | lang }}
          </div>
          <div v-if="contract.IsDownloadableContractCertificate" class="text-very-big text-green">
            <i class="fa fa-fw fa-clock-o"></i>&nbsp;{{ 'ContractInWhitelist' | lang }}
          </div>
          <div class="contract-status-icon">
            <img src="@/assets/icons/contract-ok.svg" v-if="contract.IsContractLoaded" />
            <img src="@/assets/icons/contract-add.svg" v-else />
            <!-- <img src="@/assets/icons/contract-add.svg" v-else-if="contract.IsDownloadableContractCertificate" />
            <img src="@/assets/icons/contract-wait.svg" v-else /> -->
          </div>
          <p v-if="contract.DescriptionLabel">{{contract.DescriptionLabel}}</p>
          <div class="form-grid">
            <div>
              <div class="floating-label">
                <input type="text" disabled :value="contract.StatusValidity" />
                <label>{{ 'ValidityStatus' | lang }}</label>
              </div>
              <div class="floating-label" v-if="contract._validityInterval">
                <input type="text" disabled :value="contract._validityInterval" />
                <label>{{ 'Validity' | lang }}</label>
              </div>
              <div class="floating-label" v-if="!contract._validityInterval && contract._validityStartDate">
                <input type="text" disabled :value="contract._validityStartDate" />
                <label>{{ 'ValidityFrom' | lang }}</label>
              </div>
              <div class="floating-label" v-if="!contract._validityInterval && contract._validityEndDate">
                <input type="text" disabled :value="contract._validityEndDate" />
                <label>{{ 'Expiration' | lang }}</label>
              </div>
              <div class="floating-label">
                <input type="text" disabled :value="contract._humanSaleDate" />
                <label>{{ 'BoughtDate' | lang }}</label>
              </div>
              <div class="floating-label">
                <input type="text" disabled :value="contract.SerialNumber" />
                <label>{{ 'SerialNumber' | lang }}</label>
              </div>
            </div>
          </div>
          <button v-if="!contract.SavTemporaryCommercialSuspension && !contract.SavDefinitiveCommercialSuspension" class="orange full-width" @click="greylistAfterConfirmation(contract)" :key="'gl' + cidx" :disabled="loading || !contract.IsContractLoaded">{{ 'SuspendContract' | lang }}</button>
        </div>
      </div>
      <div v-else-if="loading">{{ 'IsLoading' | lang }}</div>
      <div v-else>{{ 'CscNoContracts' | lang }}</div>
    </div>
    <button v-if="!details.IsBlackListed" class="red full-width" @click="blacklistAfterConfirmation" :disabled="loading">{{ 'DisableCSC' | lang }}</button>
    <!-- <pre>{{details}}</pre> -->
  </div>
</template>

<script>
import UserServices from '@/mixins/services/userServices'
import moment from 'moment'
import SimpleDialog from '@/dialogs/SimpleDialog'
import GreylistDialog from '@/dialogs/GreylistDialog'
import { create } from 'vue-modal-dialogs'

const simpleDialogCreator = create(SimpleDialog)
const greylistDialogCreator = create(GreylistDialog)

export default {
  name: 'CSCcontracts',
  mixins: [ UserServices ],
  props: {
    carddata: Object,
    special: {
      required: false
    }
  },
  data () {
    return {
      /* contractClassesMap: {
        2: 'used',
        1: 'warn',
        0: 'free',
        3: 'suspended'
      }, */
      details: {},
      loading: false
    }
  },
  computed: {
    anyproblem () {
      return this.details && (this.details.IsExpired || this.details.IsLocked || this.details.IsInvalid)
    },
    anywarning () {
      return this.details && (this.details.EndPeriodState === 'Expiring' || this.details.IsSaleUnavailable || this.details.IsFull)
    },
    contracts () {
      return this.carddata.ContractInfo
    },
    activeContracts () {
      return this.details.ContractNumber
    },
    isFull () {
      return this.details.IsFull
    },
    expirationDate () {
      return this.details.ExpirationDate ? moment(this.details.ExpirationDate).format('DD/MM/YYYY') : ''
    },
    holderBirthDate () {
      return moment(this.details.HolderBirthDate).format('DD/MM/YYYY')
    }
  },
  methods: {
    async blacklistAfterConfirmation () {
      try {
        this.loading = true
        let causes = await this._getDataList('7')
        let cause = await simpleDialogCreator({
          text: this.manifest['BlacklistWarningMessage_' + this.language] || this.dictValue('BlacklistWarning'),
          faicon: 'fa-exclamation-triangle',
          select: {
            label: this.dictValue('Cause'),
            opts: causes
          },
          required: true
        })
        if (cause) {
          this.loading = true
          await this._blacklistCSC(this.carddata.MediaSerialNumber, this.carddata.MediaUnicity, cause)
          this.details.IsBlackListed = true
          this.loading = false
        }
      } catch (err) {
        console.warn(err)
        this.internalBus.$emit('notify:error', {
          text: this.dictValue('errorOccured'),
          key: this.notifierKey
        })
      }
      this.loading = false
    },
    async greylistAfterConfirmation (contract) {
      try {
        this.loading = true
        let causes = await this._getDataList('8')
        console.log(causes)
        let confirmed = await greylistDialogCreator({ causes })
        if (confirmed) {
          this.loading = true
          await this._suspendContract(contract.Id, this.carddata.MediaSerialNumber, this.carddata.MediaUnicity, confirmed.cause, confirmed.date)
          contract.SavTemporaryCommercialSuspension = true
          this.loading = false
        }
      } catch (err) {
        console.warn(err)
        this.internalBus.$emit('notify:error', {
          text: this.dictValue('errorOccured'),
          key: this.notifierKey
        })
      }
      this.loading = false
    }
  },
  mounted () {
    this.loading = true
    this._getUserCSCDetails(this.carddata.MediaSerialNumber, this.carddata.MediaUnicity).then(data => {
      data.ContractInfo.forEach(c => {
        c._humanSaleDate = moment(c.SaleDate).format('DD/MM/YYYY')
        // c._validityEndDate = c.ValidityEndDate ? moment(c.ValidityEndDate).format('DD/MM/YYYY') : null
        if (!c.SlidingValidityEndDate) {
          // StartValidityDateHourMinute
          c._validityStartDate = c.ValidityStartDate ? moment(c.ValidityStartDate).format('DD/MM/YYYY') : null
          c._validityEndDate = c.ValidityEndDate ? moment(c.ValidityEndDate).format('DD/MM/YYYY') : null
        } else {
          c._validityStartDate = c.StartValidityDateHourMinute ? moment(c.StartValidityDateHourMinute).format('DD/MM/YYYY@HH:mm') : null
          c._validityEndDate = c.UseValidityEndDate ? moment(c.UseValidityEndDate).format('DD/MM/YYYY') : null
        }
        c._validityInterval = c._validityStartDate ? c._validityStartDate + ' -> ' + c._validityEndDate : null
      })
      this.details = data
      this.loading = false
    })
  }
}
</script>

<style lang="scss">

.csc-details {
  padding-left: 1.1rem;

  .floating-label {
    margin: 0.1rem 0;
  }

  .contract-box {
    position: relative;
    padding-bottom: 1rem;
  }

  .contract-status-icon {
    position: absolute;
    bottom: 5rem;
    right: 0;
    z-index: 100;

    img {
      width: 3rem;
    }
  }
}
/*
& > div {
  height: .4rem;
  border-radius: .2rem;
  
  &.free {
    background-color: lightgray;
  }
  &.used {
    background-color: green;
  }
  &.warn {
    background-color: orange;
  }
  &.suspended {
    background-color: red;
  }
}
*/

</style>
